import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { brandColors } from '@config/brandTokens';

export type PublicProfileNavId = 'player' | 'family' | 'sports';

export const PUBLIC_PROFILE_NAV_ITEMS: Array<{ id: PublicProfileNavId; label: string }> = [
  { id: 'player', label: 'Player' },
  { id: 'family', label: 'Family' },
  { id: 'sports', label: 'Sports performance' },
];

const PublicProfileSideNav: React.FC<{
  active: PublicProfileNavId;
  onSelect: (id: PublicProfileNavId) => void;
}> = ({ active, onSelect }) => {
  return (
    <Box
      component="nav"
      aria-label="Profile sections"
      sx={{
        bgcolor: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 1.25,
        overflow: 'hidden',
        p: 0.4,
        display: 'flex',
        flexDirection: { xs: 'row', lg: 'column' },
        gap: 0.25,
      }}
    >
      {PUBLIC_PROFILE_NAV_ITEMS.map((item) => {
        const selected = active === item.id;
        return (
          <ButtonBase
            key={item.id}
            onClick={() => onSelect(item.id)}
            aria-current={selected ? 'page' : undefined}
            sx={{
              justifyContent: 'flex-start',
              textAlign: 'left',
              px: 1.2,
              py: { xs: 0.75, lg: 0.95 },
              borderRadius: 0.85,
              bgcolor: selected ? brandColors.navy : 'transparent',
              color: selected ? '#fff' : brandColors.navy,
              flex: { xs: 1, lg: 'unset' },
              borderLeft: { lg: selected ? `3px solid ${brandColors.blue}` : '3px solid transparent' },
              '&:hover': {
                bgcolor: selected ? brandColors.navy : '#eef2ff',
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: selected ? 800 : 700,
                fontSize: { xs: 12, lg: 13 },
                lineHeight: 1.25,
                fontFamily: '"Sora", Arial, sans-serif',
                color: 'inherit',
              }}
            >
              {item.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default PublicProfileSideNav;
